import { tagTypeLabel } from "@/lib/utils-format";
import { X } from "@phosphor-icons/react";

export default function TagBadge({ tag, onRemove, size = "sm" }) {
  const px = size === "sm" ? "px-2 py-0.5 text-[11px]" : "px-2.5 py-1 text-xs";
  return (
    <span
      data-testid={`tag-badge-${tag.id}`}
      className={`inline-flex items-center gap-1.5 rounded-full font-mono ${px} border`}
      style={{
        background: `${tag.color}1a`,
        color: tag.color,
        borderColor: `${tag.color}40`,
      }}
      title={tagTypeLabel(tag.tag_type)}
    >
      <span className="opacity-60">{tagTypeLabel(tag.tag_type)}:</span>
      <span>{tag.name.replace(/^(event|product|status|src|cmp):/i, "")}</span>
      {onRemove && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onRemove(tag);
          }}
          className="ml-0.5 hover:opacity-100 opacity-60"
          data-testid={`tag-remove-${tag.id}`}
        >
          <X size={10} weight="bold" />
        </button>
      )}
    </span>
  );
}
